/**
 * This module defines the specification for properties that
 * ParticipatoryProjects are expected or permitted to have.
 */
import { getPropertiesMap } from "./commonProperties";
/**
 * The list of properties expected for a MeasurementUnit.
 *
 * Ideas for future expansion, if and when these things are actually useful:
 * Algorithm data to represent composite units and unit conversions
 * Localization data to represent preferred units in certain locales
 */
export const MeasurementUnitPropertiesList = [
    {
        // Example: "Meter", "U.S. Dollar", "Carbon dioxide gigatons equivalent per year"
        "key": "title",
        "type": "string",
        "inputType": "text",
        "default": null,
        "title": "Unit name",
        "description": "A full identifying name for the currency.",
        "multilingual": true,
    },
    {
        "key": "description",
        "type": "string",
        "inputType": "textarea",
        "default": null,
        "native.rows": 4,
        "title": "Unit description",
        "description": "A short description of the currency.",
        "multilingual": true,
    },
    {
        // Example: "m", "USD", "GtCO2eq/yr"
        "key": "abbreviation",
        "type": "string",
        "inputType": "text",
        "default": null,
        "title": "Unit abbreviation",
        "description": "A short, abbreviated name for this unit.",
        "multilingual": true,
    },
    {
        // Example: "$", "€"
        "key": "prefixSymbol",
        "type": "string",
        "inputType": "text",
        "default": null,
        "title": "Unit prefix symbol",
        "description": "A symbol appearing before a unit amount.",
        "multilingual": true,
    },
    {
        // Example: "m", "g", "円"
        "key": "postfixSymbol",
        "type": "string",
        "inputType": "text",
        "default": null,
        "title": "Unit postfix symbol",
        "description": "A symbol appearing after a unit amount.",
        "multilingual": true,
    },
];
/**
 * The properties expected for a MeasurementUnit, mapped by key.
 */
export const MeasurementUnitPropertiesMap = getPropertiesMap(MeasurementUnitPropertiesList);
//# sourceMappingURL=measurementUnit.js.map